import { render, staticRenderFns } from "./ExtraServiceDetail.vue?vue&type=template&id=784951c8&"
import script from "./ExtraServiceDetail.vue?vue&type=script&lang=ts&"
export * from "./ExtraServiceDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ExtraServiceDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports